import React, { useContext, useEffect, useState } from 'react';
import { useLastLocation } from 'react-router-last-location';
import { printUserNotification } from '../alert_notification_table/alert_notification_logic';
import notificationContext from '../alert_notification_table/notification_context';
import OneColumn from '../layout/containers/OneColumn';
import { Col, Row } from 'react-flexbox-grid';
import { getIsAuth } from '../../services/getIsAuth';

const Home = (props) => {
  const isAuth = getIsAuth();

  let notificationCtxt = useContext(notificationContext);
  useEffect(() => {
    if (notificationCtxt.count > 0) {
      printUserNotification();
    }
  }, []);

  let pageConfig = {
    active: 'home',
    title: 'Home',
  };

  const lastLocation = useLastLocation();
  if (lastLocation) {
    if (lastLocation.pathname === '/') {
      window.location.reload();
    }
  }
  if (!isAuth) {
    props.history.push('/');
  }

  return (
    <OneColumn {...props} pageConfig={pageConfig}>
      <section className="home">
        <Row center="xs">
          <Col xs={12}></Col>
        </Row>
      </section>
    </OneColumn>
  );
};

export default Home;
